import { Button } from '@mui/material'
import { ENDPOINT } from '../../../services/endPoints';
import React from 'react'
import { useNavigate } from 'react-router-dom'

const UserDetail = ({row, endPoint, customQueryParam}) => {
  const navigate = useNavigate();
    const handleUpdate = ()=>{
      if(endPoint === ENDPOINT.PATIENT){
        navigate(`/patient-list/users/${row.patient_code}`)
      } else if (endPoint === ENDPOINT.DASHBOARD_REFERREDTEST){
        navigate(`/hospital-referred-test-list/view/${row.hospital_id}`)
      }
      if(endPoint === ENDPOINT.DASHBOARD_ALLTEST || endPoint === ENDPOINT.DASHBOARD_REJECTEDTEST || endPoint === `${ENDPOINT.PATIENT_REFERRED_LIST}/${row.hospital_id}` ||
    endPoint === `${ENDPOINT.NURSE_DETAILS_FILTER}${customQueryParam}`){
        navigate(`/patient-list/users/record_detail_form/${row.pf_id}`, {state: {formType: row.form_type, form_code: row.form_code}})
      }
    }
  return (
    <Button size='small' onClick={()=>handleUpdate(row)} color="primary" sx={{fontSize: "10px", textWrap:"nowrap"}}>Details</Button>
  )
}

export default UserDetail